import { TrackingEvent } from '../types/tracking'

type SellerProtectionScreenClickTarget =
  | 'seller_protection_information'
  | 'ship_with_peace_of_mind'
  | 'your_earnings_are_safe'
  | 'your_sales_covered'
  | 'quick_solutions_on_your_terms'
  | 'pack_the_item_well'

type SellerProtectionScreenClickEventArgs = {
  target: SellerProtectionScreenClickTarget
  screen?: string | null
  details?: string | null
  transactionId?: string | null
}

export const sellerProtectionScreenClickEvent = (
  args: SellerProtectionScreenClickEventArgs,
): TrackingEvent => {
  const { details, transactionId, screen, target } = args

  return {
    event: 'seller_protection_screen.click',
    extra: {
      screen,
      target,
      transaction_id: transactionId,
      details,
    },
  }
}

type SellerProtectionScreenViewEventArgs = {
  details?: string | null
  timeSpentInScreenMS: string
}

export const sellerProtectionScreenViewEvent = (
  args: SellerProtectionScreenViewEventArgs,
): TrackingEvent => {
  const { details, timeSpentInScreenMS } = args

  return {
    event: 'seller_protection_screen.view',
    extra: {
      screen: 'seller_protection_information',
      details,
      time_spent_in_screen_ms: timeSpentInScreenMS,
    },
  }
}
